import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { changeFavoriteTableSettings } from '../../../redux/ai-studio/aiStudioReducer';
import WithLabel, { LABEL_STYLES } from '../../../components/with-label/WithLabel';
import { COMMON_PAGE_SIZE_OPTIONS } from '../../../constants';
import CommonDropdown from '../../../components/common-dropdown/CommonDropdown';

import scss from './GalleryFilters.module.scss';

function GalleryFilters() {
  const { t } = useTranslation('studio');
  const dispatch = useDispatch();

  const size = useSelector((state) => state.aiStudio.favoriteTableSettings.size);

  const handleChangeTableSize = (newSize) => {
    dispatch(changeFavoriteTableSettings({ size: newSize, page: 0 }));
  };

  return (
    <div className={scss.wrapper}>
      <WithLabel label={t('show')} variant={LABEL_STYLES.ROW} isBold maxWidth={150} isTwoDots>
        <CommonDropdown options={COMMON_PAGE_SIZE_OPTIONS} value={size} onSelect={handleChangeTableSize} />
      </WithLabel>
    </div>
  );
}

export default GalleryFilters;
